export default "__VITE_ASSET__CUGHu3FQ__"